/* eslint-disable */
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Tooltip from "@material-ui/core/Tooltip";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import PropTypes from "prop-types";
import React, {
  useState,
  forwardRef,
  useRef,
  useImperativeHandle,
} from "react";
import { useTranslation } from "react-i18next";
import {
  StyledTableCell,
  StyledTableRow,
  useStyles,
} from "../../../components/profiles/ProfileStyles";
import Edit from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { green } from "@material-ui/core/colors";
import { normalizeStr } from "utils/general/strings";
import RedoIcon from "@material-ui/icons/Redo";
import { createContent } from "utils/tables/createContent";

const useStyles1 = makeStyles(theme => ({
  root: {
    flexShrink: 0,
    flexGrow: 1,
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing(2.5),
  },
}));

var id = [];
var idObject = [];
id.pop();
idObject.pop();

function getCodeListType(row) {
  const response = [];

  if (row["lsbdCodeF"]) response.push("lsbdCodeF");
  if (row["fcpcCodeF"]) response.push("fcpcCodeF");
  if (row["ufcCodeF"]) response.push("ufcCodeF");
  if (row["externalCodeF"]) response.push("externalCodeF");

  if (response.length === 0) response.push("-");

  return response[0];
}

function desc(a, b, orderBy) {
  let orderByNameA = "";
  let orderByNameB = "";

  if (orderBy === "ufcCodeF") {
    orderByNameA = getCodeListType(a);
    orderByNameB = getCodeListType(b);
  } else {
    orderByNameA = orderBy;
    orderByNameB = orderBy;
  }

  if (a[orderByNameA] === null) a[orderByNameA] = "";
  if (b[orderByNameB] === null) b[orderByNameB] = "";

  if (orderByNameA === "-") return 1;
  if (orderByNameB === "-") return -1;

  if (a[orderByNameA] === true) return 1;
  if (a[orderByNameA] === false) return -1;
  if (b[orderByNameB] === false) return -1;
  if (b[orderByNameB] === true) return 1;

  if (orderBy === "newPlace") {
    if (
      b[orderByNameB] &&
      a[orderByNameB] &&
      normalizeStr(b[orderByNameB].toString()) <
        normalizeStr(a[orderByNameA].toString())
    )
      return -1;
    if (
      b[orderByNameB] &&
      a[orderByNameB] &&
      normalizeStr(b[orderByNameB].toString()) >
        normalizeStr(a[orderByNameA].toString())
    )
      return 1;
  } else {
    if (
      normalizeStr(b[orderByNameB].toString()) <
      normalizeStr(a[orderByNameA].toString())
    ) {
      return -1;
    }
    if (
      normalizeStr(b[orderByNameB].toString()) >
      normalizeStr(a[orderByNameA].toString())
    ) {
      return 1;
    }
  }
  return 0;
}

const CustomPaginationActionsTable = props => {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState({});
  const [rowsLength, setRowsLength] = useState(0);
  const [headers, setHeaders] = useState([]);
  const [mainField, setMainField] = useState("");
  const [visibleHeaders, setVisibleHeaders] = useState([]);
  const [sortedFields, setSortedFields] = useState([]);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("name");
  const [checked, setchecked] = useState(0);
  const [context, setContext] = useState("");
  const [type, setType] = useState("");

  React.useEffect(() => {
    setHeaders(props.headers);
    setRows(props.rows);
    setRowsLength(props.rows.length);
    setMainField(props.mainField);
    setVisibleHeaders(props.visibleHeaders);
    setSortedFields(props.sortedFields);
    setContext(props.context);
    setType(props.type);
    if (
      props.type === "return_of_equipment" &&
      props.itemsToReturn.length === 0
    ) {
      clearChecked();
    }
  }, [
    props.headers,
    props.mainField,
    props.rows,
    props.visibleHeaders,
    props.itemsToReturn,
  ]);

  function handlePageChange(event, newPage) {
    setPage(newPage);
  }

  const handleRowsPerPageChange = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleRequestSort = (event, property) => {
    const isDesc = orderBy === sortedFields[property] && order === "desc";
    setOrder(isDesc ? "asc" : "desc");
    setOrderBy(sortedFields[property]);
  };

  function getCodeList(row) {
    const response = [];
    if (row["lsbdCodeF"]) response.push(row["lsbdCodeF"]);
    if (row["fcpcCodeF"]) response.push(row["fcpcCodeF"]);
    if (row["ufcCodeF"]) response.push(row["ufcCodeF"]);

    if (response.length === 0) {
      if (
        row.libraryExemplar &&
        row.libraryExemplar.length > 0 &&
        row.libraryExemplar[0].exemplarCode !== null
      ) {
        response.push("BIB-00" + row.libraryExemplar[0].exemplarCode);
      } else {
        response.push("-");
      }
    }
    return response;
  }

  const UsersTableHead = props => {
    const { order, orderBy, onRequestSort } = props;
    const [t] = useTranslation();
    const paginationTop = action => e => {
      var selector = "[aria-label^='" + action + "']";
      document.querySelector(selector).click();
      e.preventDefault();
    };
    const createSortHandler = property => event => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          {type === "return_of_equipment" && context === "edit" && (
            <StyledTableCell>
              <Checkbox
                className="projectParticipant"
                //id={"divParticipant" + index}
                color="primary"
                //key={row.id}
                //value={row.id}
                ///onClick={change}
                // checked={verify}
                //onChange={handleSwitch}
              />
            </StyledTableCell>
          )}
          {visibleHeaders.map((header, index) => (
            <StyledTableCell
              key={index}
              size="small"
              align="left"
              sortDirection={orderBy === sortedFields[index] ? order : false}
            >
              <TableSortLabel
                active={orderBy === sortedFields[index]}
                direction={order}
                onClick={createSortHandler(index)}
                disabled={
                  props.type === "use_of_equpment" ? index == 7 : index === 6
                }
              >
                {header && header.toUpperCase()}
                {orderBy === sortedFields[index] ? (
                  <span className={classes.visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </span>
                ) : null}
              </TableSortLabel>
            </StyledTableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  };

  var idCurrentOfPage = [];
  var listIds = [];

  UsersTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
  };

  var verify = false;
  function verifyIsChecked(idVerify) {
    idCurrentOfPage.push(idVerify);
    for (var i in idCurrentOfPage) {
      for (var j in id) {
        if (idCurrentOfPage[i] == id[j]) {
          listIds.push(idCurrentOfPage[i]);
        }
      }
    }
    verify = listIds.includes(idVerify);
  }

  let placesChecked = new Object();

  function handleSwitchChangeOfPlace(e) {
    var contains = id.includes(e.target.value);
    if (contains) {
      id = id.filter(el => el !== e.target.value);
      idObject = idObject.filter(el => el.id != e.target.value);
      props.setItemsToBeMoved(idObject);
    } else {
      id.push(e.target.value);
      placesChecked = rows.filter(el => el.id == e.target.value);
      idObject.push(placesChecked[0]);
      props.setItemsToBeMoved(placesChecked);
    }
  }

  React.useEffect(() => {
    props.type === "change_of_local" && props.setItemsToBeMoved(idObject);
  }, [
    idObject.length,
    id.length,
    listIds.length,
    idCurrentOfPage.length,
    JSON.stringify(idObject),
  ]);

  function change() {
    setchecked(Math.random() * 1000);
  }
  function clearChecked() {
    while (id.length > 0) {
      id.pop();
    }
    while (idObject.length > 0) {
      idObject.pop();
    }
  }

  let returnEquipmentChecked = new Object();

  function handleSwitch(e) {
    var contains = id.includes(e.target.value);
    if (contains) {
      id = id.filter(el => el !== e.target.value);
      idObject = idObject.filter(el => el.id != e.target.value);
      props.setItemsToBeReturn(idObject);
    } else {
      id.push(e.target.value);
      returnEquipmentChecked = rows.filter(el => el.id == e.target.value);
      idObject.push(returnEquipmentChecked[0]);
      props.setItemsToBeReturn(returnEquipmentChecked);
    }
  }

  React.useEffect(() => {
    props.type === "return_of_equipment" && props.setItemsToBeReturn(idObject);
  }, [
    idObject.length,
    id.length,
    listIds.length,
    idCurrentOfPage.length,
    JSON.stringify(idObject),
  ]);

  return (
    <Paper className={classes.root}>
      <div className={classes.tableWrapper}>
        <Table className={classes.table} size="small">
          {rows.length > 0 && (
            <UsersTableHead
              classes={classes}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />
          )}
          <TableBody>
            {createContent(rows, headers, order, orderBy, desc)
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => (
                <StyledTableRow key={row.id + checked}>
                  {props.type === "return_of_equipment" &&
                    context === "edit" && (
                      <TableCell
                        size="small"
                        align="left"
                        onChange={verifyIsChecked(row.id)}
                      >
                        <Checkbox
                          className="projectParticipant"
                          id={"divParticipant" + index}
                          color="primary"
                          key={row.id}
                          value={row.id}
                          onClick={change}
                          checked={verify}
                          onChange={handleSwitch}
                        />
                      </TableCell>
                    )}
                  {props.type === "use_of_equipment" && (
                    <React.Fragment>
                      <TableCell size="small">{row["category"]}</TableCell>
                      <TableCell size="small">{row["description"]}</TableCell>
                      <TableCell size="small">{row["place"]}</TableCell>
                      <TableCell size="small">
                        {row["itemName"] ? (
                          <React.Fragment>
                            {row["itemName"]}
                            <CheckCircleIcon
                              style={{
                                color: green[500],
                              }}
                            />
                          </React.Fragment>
                        ) : (
                          "-"
                        )}
                      </TableCell>
                      <TableCell size="small">
                        {/* {row["code"] ?
                          <React.Fragment>
                            {row["code"]}
                            <CheckCircleIcon style={{ color: green[500] }} />
                          </React.Fragment>
                          : "-"
                        }
                        {row["code"] &&
                          <Tooltip title={
                            row["code"].length > 1 ? row["code"].splice(1).join(' e ') : ""
                          } aria-label="details" placement="top">
                            <span style={{ fontWeight: "bold", color: "#6D6F71" }}>
                              {row["code"].length > 1 ? ` +${row["code"].length - 1}` : ""}
                            </span>
                          </Tooltip>} */}

                        {getCodeList(row)[0]}
                        <Tooltip
                          title={
                            getCodeList(row).length > 1
                              ? getCodeList(row).splice(1).join(" e ")
                              : ""
                          }
                          aria-label="details"
                          placement="top"
                        >
                          <span
                            style={{
                              fontWeight: "bold",
                              color: "#6D6F71",
                            }}
                          >
                            {getCodeList(row).length > 1
                              ? ` +${getCodeList(row).length - 1}`
                              : ""}
                          </span>
                        </Tooltip>
                      </TableCell>
                      <TableCell size="small">
                        {row["serialNumber"] ? (
                          <React.Fragment>
                            {row["serialNumber"]}
                            <CheckCircleIcon
                              style={{
                                color: green[500],
                              }}
                            />
                          </React.Fragment>
                        ) : (
                          "-"
                        )}
                      </TableCell>
                      <TableCell size="small">
                        {row["newStatus"] ? (
                          <React.Fragment>
                            {row["newStatus"]}
                            <CheckCircleIcon
                              style={{
                                color: green[500],
                              }}
                            />
                          </React.Fragment>
                        ) : (
                          "-"
                        )}
                      </TableCell>

                      {context === "edit" && (
                        <React.Fragment>
                          <TableCell size="small" align="right">
                            <div
                              style={{
                                marginTop: "auto",
                                marginBottom: "auto",
                                display: "flex",
                                flexWrap: "nowrap ",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Tooltip
                                title={"limpar"}
                                aria-label="details"
                                placement="top"
                              >
                                <IconButton
                                  className={classes.icons}
                                  onClick={() =>
                                    props.setRemoveIdUseEquipment(row["id"])
                                  }
                                >
                                  <RedoIcon />
                                </IconButton>
                              </Tooltip>
                            </div>
                          </TableCell>
                          <TableCell size="small">
                            <Tooltip
                              title="Editar"
                              aria-label="Editar"
                              placement="top"
                            >
                              <IconButton
                                className={classes.icons}
                                onClick={() =>
                                  props.setEditUseEquipment({
                                    open: true,
                                    obj: row,
                                  })
                                }
                              >
                                <Edit />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  )}
                  {props.type === "return_of_equipment" && (
                    <React.Fragment>
                      <TableCell size="small">
                        {row["name"] ? row["name"] : "-"}
                      </TableCell>
                      <TableCell size="small">
                        {getCodeList(row)[0]}
                        <Tooltip
                          title={
                            getCodeList(row).length > 1
                              ? getCodeList(row).splice(1).join(" e ")
                              : ""
                          }
                          aria-label="details"
                          placement="top"
                        >
                          <span
                            style={{
                              fontWeight: "bold",
                              color: "#6D6F71",
                            }}
                          >
                            {getCodeList(row).length > 1
                              ? ` +${getCodeList(row).length - 1}`
                              : ""}
                          </span>
                        </Tooltip>
                      </TableCell>
                      <TableCell size="small">
                        {row["serialNumber"] ? row["serialNumber"] : "-"}
                      </TableCell>
                      <TableCell size="small">{row["place"]}</TableCell>
                      <TableCell size="small">
                        {row["newResponsible"] && (
                          <React.Fragment>
                            {row["newResponsible"]}
                            <CheckCircleIcon
                              style={{
                                color: green[500],
                              }}
                            />
                          </React.Fragment>
                        )}
                      </TableCell>
                      <TableCell size="small">
                        {row["newPlace"] && (
                          <React.Fragment>
                            {row["newPlace"]}
                            <CheckCircleIcon
                              style={{
                                color: green[500],
                              }}
                            />
                          </React.Fragment>
                        )}
                      </TableCell>
                      <TableCell size="small">
                        {row["newStatus"] && (
                          <React.Fragment>
                            {row["newStatus"]}
                            <CheckCircleIcon
                              style={{
                                color: green[500],
                              }}
                            />
                          </React.Fragment>
                        )}
                      </TableCell>
                      <TableCell size="small">
                        {row["returned"] ? "Sim" : "Não"}
                      </TableCell>
                      {context === "edit" && (
                        <React.Fragment>
                          <TableCell size="small" align="right">
                            <div
                              style={{
                                marginTop: "auto",
                                marginBottom: "auto",
                                display: "flex",
                                flexWrap: "nowrap ",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Tooltip
                                title={"limpar"}
                                aria-label="details"
                                placement="top"
                              >
                                <IconButton
                                  className={classes.icons}
                                  onClick={() =>
                                    props.setRemoveIdReturnEquipment(row["id"])
                                  }
                                >
                                  <RedoIcon />
                                </IconButton>
                              </Tooltip>
                            </div>
                          </TableCell>
                          <TableCell size="small">
                            <Tooltip
                              title="Editar"
                              aria-label="Editar"
                              placement="top"
                            >
                              <IconButton
                                className={classes.icons}
                                onClick={() =>
                                  props.setEditReturnOneEquipment({
                                    open: true,
                                    obj: row,
                                  })
                                }
                              >
                                <Edit />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  )}
                  {props.type == "change_of_local" && (
                    <React.Fragment>
                      <TableCell size="small">
                        {row["name"] ? row["name"] : "-"}
                      </TableCell>
                      <TableCell size="small">{row["category"]}</TableCell>
                      <TableCell size="small">
                        {getCodeList(row)[0]}
                        <Tooltip
                          title={
                            getCodeList(row).length > 1
                              ? getCodeList(row).splice(1).join(" e ")
                              : ""
                          }
                          aria-label="details"
                          placement="top"
                        >
                          <span
                            style={{
                              fontWeight: "bold",
                              color: "#6D6F71",
                            }}
                          >
                            {getCodeList(row).length > 1
                              ? ` +${getCodeList(row).length - 1}`
                              : ""}
                          </span>
                        </Tooltip>
                      </TableCell>
                      <TableCell size="small">
                        {row["serialNumber"] ? row["serialNumber"] : "-"}
                      </TableCell>
                      <TableCell size="small">{row["oldPlace"]}</TableCell>
                      <TableCell size="small">{row["newPlace"]}</TableCell>
                      {context === "edit" ? (
                        <TableCell
                          size="small"
                          align="left"
                          onChange={verifyIsChecked(row.id)}
                        >
                          <Checkbox
                            className="changeOfPlace"
                            id={"divMoved" + index}
                            color="primary"
                            key={row.id}
                            value={row.id}
                            onClick={change}
                            checked={verify}
                            onChange={handleSwitchChangeOfPlace}
                          />
                        </TableCell>
                      ) : (
                        <TableCell>{row["moved"] ? "Sim" : "Não"}</TableCell>
                      )}
                    </React.Fragment>
                  )}
                </StyledTableRow>
              ))}
          </TableBody>
        </Table>
        {rows.length > 0 && (
          <TableFooter style={{ float: "right" }}>
            <TablePagination
              labelRowsPerPage={"Resultados por página"}
              count={rowsLength}
              rowsPerPage={rowsPerPage}
              page={page}
              component="div"
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
              //ActionsComponent={TablePaginationActions}
            />
          </TableFooter>
        )}
      </div>
    </Paper>
  );
};

CustomPaginationActionsTable.propTypes = {
  rows: PropTypes.array.isRequired,
  headers: PropTypes.array.isRequired,
  visibleHeaders: PropTypes.array.isRequired,
  mainField: PropTypes.string.isRequired,
};

export default CustomPaginationActionsTable;
